var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFileIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7a.875.875 0 0 0 0 1.75h.875a.875.875 0 0 0 0-1.75zm4.375 10.5H5.25a.875.875 0 0 1-.875-.875V4.375A.875.875 0 0 1 5.25 3.5h4.375v2.625A2.625 2.625 0 0 0 12.25 8.75h2.625v1.75a.875.875 0 1 0 1.75 0V7.822q-.015-.121-.052-.236v-.079a1 1 0 0 0-.167-.244l-5.25-5.25a1 1 0 0 0-.245-.167.3.3 0 0 0-.087 0 1 1 0 0 0-.271-.096H5.25a2.625 2.625 0 0 0-2.625 2.625v12.25A2.625 2.625 0 0 0 5.25 19.25h6.125a.875.875 0 1 0 0-1.75m0-12.766L13.641 7H12.25a.875.875 0 0 1-.875-.875zm.875 5.766H7a.875.875 0 0 0 0 1.75h5.25a.875.875 0 1 0 0-1.75m5.871 5.504a.873.873 0 0 0-1.242 0l-.254.262V14a.875.875 0 1 0-1.75 0v2.266l-.254-.262a.878.878 0 1 0-1.242 1.242l1.75 1.75q.126.12.289.184a.82.82 0 0 0 .665 0 .9.9 0 0 0 .288-.184l1.75-1.75a.873.873 0 0 0 0-1.242M10.5 15.75a.875.875 0 1 0 0-1.75H7a.875.875 0 0 0 0 1.75z",
    fill: "#001489"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFileIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/file-icon.ce4dc68fefe4d657fc7319e4cd6299a5.svg";